import { zAttrTextArea } from "src/common/attrEdit/components";
import {
  zAttrArticleView,
  zAttrFinancialView,
  zAttrFormulaCell,
  zAttrLinked,
  zChildEntitiesCellInfo,
  zContentLangInfo,
  zDictRef,
  zFileList,
  zImgList,
  zLinkStd,
  zLinkView,
  zObectRef,
  zPersonCellInfo,
  zSimpleText,
  zTag,
} from "src/common/attrView/componentsDefs";
import { zAttrFormulaWithFinancialView } from "src/common/attrView/componentsDefs/ZAttrFormulaWithFinancialView";
import { zColorView } from "src/common/attrView/componentsDefs/ZColorView";
import { LabelMakerDef } from "../types/MakeLabelParams";
import { genLabelKey } from "../utils/generateLabelKey";
import { getEditorName } from "../utils/meta/getEditorName";
import { getViewName } from "../utils/meta/getViewName";
import { defineSimpleLabel, defineTagLabel } from "./common";
import { makeDictRefLabel } from "./dict/makeDictRefLabel";
import { makeFileListLabel } from "./file/makeFileListLabel";
import { makeImageListLabel } from "./image/makeImageListLabel";
import { makeLinkExternalLabel } from "./link/makeLinkExternalLabel";
import { makeLinkInternalLabel } from "./link/makeLinkInternalLabel";
import { makeContentLangLabel } from "./makeContentLangLabel";
import { makeTextAreaLabel } from "./makeTextAreaLabel";
import { makeChildEntitiesLabel } from "./object/makeChildEntitiesLabel";
import { makeObjectRefLabel } from "./object/makeObjectRefLabel";
import { makeUserListLabel } from "./object/makeUserListLabel";
import { makeFinancialLabel } from "./makeFinancialLabel";
import { makeAttrLinkedLabel } from "./object/makeAttrLinkedLabel";
import { makeColorViewLabel } from "./ColorView/makeColorViewLabel";

export const makeLabelsDefs = (): LabelMakerDef[] => [
  {
    keygen: () => genLabelKey([getViewName(zSimpleText)]),
    label: defineSimpleLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zTag)]),
    label: defineTagLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zDictRef)]),
    label: makeDictRefLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zObectRef)]),
    label: makeObjectRefLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zChildEntitiesCellInfo)]),
    label: makeChildEntitiesLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zPersonCellInfo)]),
    label: makeUserListLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zAttrLinked)]),
    label: makeAttrLinkedLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zAttrFinancialView)]),
    label: makeFinancialLabel,
  },
  {
    keygen: () =>
      genLabelKey([getViewName(zSimpleText), getEditorName(zAttrTextArea)]),
    label: makeTextAreaLabel,
  },
  // можно оптимизировать до zSimpleText
  {
    keygen: () => genLabelKey([getViewName(zAttrArticleView)]),
    label: defineSimpleLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zAttrFormulaCell)]),
    label: defineSimpleLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zAttrFormulaWithFinancialView)]),
    label: defineSimpleLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zContentLangInfo)]),
    label: makeContentLangLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zLinkStd)]),
    label: makeLinkInternalLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zLinkView)]),
    label: makeLinkExternalLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zImgList)]),
    label: makeImageListLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zFileList)]),
    label: makeFileListLabel,
  },
  {
    keygen: () => genLabelKey([getViewName(zColorView)]),
    label: makeColorViewLabel,
  },
];
export const makeLabelsDefs4EntityCard = (): LabelMakerDef[] => [
  /**
   * таким образом мы можем переопределить labelMaker для конкретного view, потому что стратегия интерпретации
   * находит первый попавшийся labelMaker, который соответствует ключу, поэтому если мы хотим переопределить labelMaker для zImgList,
   * то мы должны добавить его в начало массива, чтобы он был выбран первым.
   */
  {
    keygen: () => genLabelKey([getViewName(zImgList)]),
    label: (params) => makeImageListLabel(params, "medium"),
  },
  ...makeLabelsDefs(),
];
